var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 3V4.875M14.375 3V4.875M2.5 16.125V6.75C2.5 6.25272 2.69754 5.77581 3.04917 5.42417C3.40081 5.07254 3.87772 4.875 4.375 4.875H15.625C16.1223 4.875 16.5992 5.07254 16.9508 5.42417C17.3025 5.77581 17.5 6.25272 17.5 6.75V16.125M2.5 16.125C2.5 16.6223 2.69754 17.0992 3.04917 17.4508C3.40081 17.8025 3.87772 18 4.375 18H15.625C16.1223 18 16.5992 17.8025 16.9508 17.4508C17.3025 17.0992 17.5 16.6223 17.5 16.125M2.5 16.125V9.875C2.5 9.37772 2.69754 8.90081 3.04917 8.54917C3.40081 8.19754 3.87772 8 4.375 8H15.625C16.1223 8 16.5992 8.19754 16.9508 8.54917C17.3025 8.90081 17.5 9.37772 17.5 9.875V16.125M10 11.125H10.0067V11.1317H10V11.125ZM10 13H10.0067V13.0067H10V13ZM10 14.875H10.0067V14.8817H10V14.875ZM8.125 13H8.13167V13.0067H8.125V13ZM8.125 14.875H8.13167V14.8817H8.125V14.875ZM6.25 13H6.25667V13.0067H6.25V13ZM6.25 14.875H6.25667V14.8817H6.25V14.875ZM11.875 11.125H11.8817V11.1317H11.875V11.125ZM11.875 13H11.8817V13.0067H11.875V13ZM11.875 14.875H11.8817V14.8817H11.875V14.875ZM13.75 11.125H13.7567V11.1317H13.75V11.125ZM13.75 13H13.7567V13.0067H13.75V13Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calenderIcon.785b33323a282d7a44b324df1df2288d.svg";
export { ForwardRef as ReactComponent };